import React from "react";
//import ReactDOM from "react-dom";
//import { PDFDownloadLink, PDFViewer, Page, Text, View, Document, StyleSheet, Font, Image } from "@react-pdf/renderer";
import { BlobProvider, Page, Text, View, Document, StyleSheet, Font, Image } from "@react-pdf/renderer";
import Header from "./header.component";
import moment from "moment";
import getAge from "../misc/getAge";
import getZeroPad from "../misc/getZeroPad";
import getSalutation from "../misc/getSalutation";
import convertRefValueToStr from "../misc/convertRefValueToStr";

Font.register({
    family: "Segoe UI",
    fonts: [
        {
            src: "/fonts/Segoe UI/Segoe UI.ttf"
        },
        {
            src: "/fonts/Segoe UI/Segoe UI Bold.ttf",
            fontWeight: "bold"
        },
        {
            src: "/fonts/Segoe UI/Segoe UI Italic.ttf",
            fontWeight: "normal",
            fontStyle: "italic"
        }
    ]
});

// Create styles
const styles = StyleSheet.create({
    page: {
        paddingLeft: 10,
        paddingRight: 10,
        marginLeft: 1,
        marginTop: 10,
        marginRight: 1,
        marginBottom: 12,
        fontFamily: "Segoe UI",
        fontSize: 8,
        color: "#111827"
    },
    titleWrap: {
        marginTop: 2,
        marginBottom: 6,
        alignItems: "center"
    },
    title: {
        fontWeight: "bold",
        fontSize: 11,
        letterSpacing: 0.2,
        textAlign: "center"
    },
    subtitle: {
        marginTop: 1,
        fontSize: 8,
        color: "#4b5563",
        textAlign: "center"
    }
});

// Create Document Component
const MyDocument = ({ patient, labResultData, indicators, authorizedBy, qrImage, notes }) => {
    const isFlagged = (indicator) => indicator === "L" || indicator === "H" || indicator === "Positive" || indicator === "Inconclusive";

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <Header />
                <View style={styles.titleWrap}>
                    <Text style={styles.title}>HASIL LABORATORIUM / LABORATORY RESULT</Text>
                </View>

                <View style={{ borderWidth: 1, borderColor: "#cbd5e1", borderRadius: 3, overflow: "hidden", marginBottom: 6 }}>
                    <Text style={{ backgroundColor: "#f3f4f6", borderBottomWidth: 1, borderBottomColor: "#cbd5e1", paddingVertical: 3, paddingHorizontal: 6, fontSize: 8, fontWeight: "bold" }}>Informasi pasien / Patient information</Text>
                    <View style={{ padding: 6 }}>
                        <View style={{ flexDirection: "row", marginBottom: 4 }}>
                            <View style={{ width: "25%", paddingRight: 4 }}>
                                <Text style={{ fontSize: 8, color: "#374151", fontWeight: "bold" }}>No. Pemeriksaan / Exam No</Text>
                                <Text style={{ fontSize: 8, color: "#111827" }}>
                                    {moment(labResultData.completedAt).format("YYMMDD")}
                                    {getZeroPad(labResultData.lab_result_no, 3)}
                                </Text>
                            </View>
                            <View style={{ width: "25%", paddingHorizontal: 4 }}>
                                <Text style={{ fontSize: 8, color: "#374151", fontWeight: "bold" }}>MRN</Text>
                                <Text style={{ fontSize: 8, color: "#111827" }}>{patient.mrn}</Text>
                            </View>
                            <View style={{ width: "25%", paddingHorizontal: 4 }}>
                                <Text style={{ fontSize: 8, color: "#374151", fontWeight: "bold" }}>Sampel Diambil / Sample Taken</Text>
                                <Text style={{ fontSize: 8, color: "#111827" }}>{labResultData.sampleTakenAt && moment(labResultData.sampleTakenAt).format("DD-MM-YYYY HH:mm")}</Text>
                            </View>
                            <View style={{ width: "25%", paddingLeft: 4 }}>
                                <Text style={{ fontSize: 8, color: "#374151", fontWeight: "bold" }}>Sampel Diterima / Sample Received</Text>
                                <Text style={{ fontSize: 8, color: "#111827" }}>{labResultData.sampleReceivedAt && moment(labResultData.sampleReceivedAt).format("DD-MM-YYYY HH:mm")}</Text>
                            </View>
                        </View>
                        <View style={{ flexDirection: "row", marginBottom: 4 }}>
                            <View style={{ width: "50%", paddingRight: 6 }}>
                                <Text style={{ fontSize: 8, color: "#374151", fontWeight: "bold" }}>Nama / Patient Name</Text>
                                <Text style={{ fontSize: 8, color: "#111827" }}>
                                    {getSalutation(patient.fullName, patient.sex, patient.dateOfBirth, patient.maritalStatus)}
                                    {patient.fullName}
                                </Text>
                            </View>
                            <View style={{ width: "50%", paddingLeft: 6 }}>
                                <Text style={{ fontSize: 8, color: "#374151", fontWeight: "bold" }}>Selesai / Completed</Text>
                                <Text style={{ fontSize: 8, color: "#111827" }}>{moment(labResultData.completedAt).format("DD-MM-YYYY HH:mm")}</Text>
                            </View>
                        </View>
                        <View style={{ flexDirection: "row", marginBottom: 4 }}>
                            <View style={{ width: "50%", paddingRight: 6 }}>
                                <Text style={{ fontSize: 8, color: "#374151", fontWeight: "bold" }}>Jenis Kelamin / Sex</Text>
                                <Text style={{ fontSize: 8, color: "#111827" }}>
                                    {patient.sex} / {patient.sex === "Laki-laki" ? "Male" : "Female"}
                                </Text>
                            </View>
                            <View style={{ width: "50%", paddingLeft: 6 }}>
                                <Text style={{ fontSize: 8, color: "#374151", fontWeight: "bold" }}>Tgl Lahir (Usia) / DOB (Age)</Text>
                                <Text style={{ fontSize: 8, color: "#111827" }}>
                                    {moment(patient.dateOfBirth).format("DD-MM-YYYY")} / {getAge(patient.dateOfBirth, new Date())}
                                </Text>
                            </View>
                        </View>
                        <View style={{ flexDirection: "row", marginBottom: 4 }}>
                            <View style={{ width: "50%", paddingRight: 6 }}>
                                <Text style={{ fontSize: 8, color: "#374151", fontWeight: "bold" }}>Dokter / Doctor</Text>
                                <Text style={{ fontSize: 8, color: "#111827" }}>{labResultData.doctor ? labResultData.doctor : labResultData.requestedBy}</Text>
                            </View>
                            <View style={{ width: "50%", paddingLeft: 6 }}>
                                <Text style={{ fontSize: 8, color: "#374151", fontWeight: "bold" }}>Alamat / Address</Text>
                                <Text style={{ fontSize: 8, color: "#111827" }}>{labResultData.from}</Text>
                            </View>
                        </View>
                        <View style={{ flexDirection: "row" }}>
                            <View style={{ width: "100%" }}>
                                <Text style={{ fontSize: 8, color: "#374151", fontWeight: "bold" }}>Jenis Pemeriksaan / Exam</Text>
                                <Text style={{ fontSize: 8, color: "#111827" }}>
                                    {labResultData.category} - {labResultData.name}
                                </Text>
                            </View>
                        </View>
                    </View>
                </View>

                <View style={{ borderWidth: 1, borderColor: "#cbd5e1", borderRadius: 3, overflow: "hidden", marginBottom: 6 }}>
                    <Text style={{ backgroundColor: "#f3f4f6", borderBottomWidth: 1, borderBottomColor: "#cbd5e1", paddingVertical: 3, paddingHorizontal: 6, fontSize: 8, fontWeight: "bold" }}>Rincian hasil / Result details</Text>
                    <View style={{ flexDirection: "row", backgroundColor: "#1f2937" }}>
                            <Text style={{ width: "28%", color: "#ffffff", fontSize: 8, fontWeight: "bold", paddingVertical: 3, paddingHorizontal: 4, borderRightWidth: 1, borderRightColor: "#334155" }}>Pemeriksaan / Examination</Text>
                            <Text style={{ width: "15%", color: "#ffffff", fontSize: 8, fontWeight: "bold", paddingVertical: 3, paddingHorizontal: 4, borderRightWidth: 1, borderRightColor: "#334155" }}>Hasil / Result</Text>
                            <Text style={{ width: "8%", color: "#ffffff", fontSize: 8, fontWeight: "bold", paddingVertical: 3, paddingHorizontal: 4, borderRightWidth: 1, borderRightColor: "#334155" }}>Flag</Text>
                            <Text style={{ width: "9%", color: "#ffffff", fontSize: 8, fontWeight: "bold", paddingVertical: 3, paddingHorizontal: 4, borderRightWidth: 1, borderRightColor: "#334155" }}>Satuan / Unit</Text>
                            <Text style={{ width: "40%", color: "#ffffff", fontSize: 8, fontWeight: "bold", paddingVertical: 3, paddingHorizontal: 4 }}>Nilai Rujukan / Reference</Text>
                    </View>
                    {labResultData.results.length > 0 &&
                        labResultData.results.map((item, index) => {
                            const flagged = isFlagged(indicators[index]);
                            return (
                                <View key={index} style={{ flexDirection: "row", borderTopWidth: 1, borderTopColor: "#e5e7eb" }}>
                                        <Text style={{ width: "28%", fontSize: 8, paddingVertical: 3, paddingHorizontal: 4, borderRightWidth: 1, borderRightColor: "#e5e7eb" }}>
                                        {item.name}
                                        {item.name.indexOf("Antigen SARS") >= 0 ? "\nSample: nasopharyngeal swab / Sampel: swab nasofaring" : ""}
                                    </Text>
                                        <Text style={{ width: "15%", fontSize: 8, paddingVertical: 3, paddingHorizontal: 4, borderRightWidth: 1, borderRightColor: "#e5e7eb", fontWeight: "bold", color: flagged ? "#b91c1c" : "#111827" }}>
                                        {labResultData.attachmentUrl ? "TERLAMPIR / ATTACHED" : item.value}
                                    </Text>
                                        <Text style={{ width: "8%", fontSize: 8, paddingVertical: 3, paddingHorizontal: 4, borderRightWidth: 1, borderRightColor: "#e5e7eb", textAlign: "center", color: flagged ? "#b91c1c" : "#111827" }}>
                                        {indicators[index]}
                                    </Text>
                                        <Text style={{ width: "9%", fontSize: 8, paddingVertical: 3, paddingHorizontal: 4, borderRightWidth: 1, borderRightColor: "#e5e7eb" }}>
                                        {item.unit ? item.unit.replace("<sup>", "^").replace("</sup>", "") : ""}
                                    </Text>
                                        <Text style={{ width: "40%", fontSize: 8, paddingVertical: 3, paddingHorizontal: 4 }}>
                                        {convertRefValueToStr(item.refValues, patient.dateOfBirth, item.name).replace("<br/>", ". ")}
                                    </Text>
                                </View>
                            );
                        })}
                </View>

                {notes && notes.length > 0 && (
                    <View style={{ borderWidth: 1, borderColor: "#cbd5e1", borderRadius: 3, overflow: "hidden", marginBottom: 6 }}>
                        <Text style={{ backgroundColor: "#f3f4f6", borderBottomWidth: 1, borderBottomColor: "#cbd5e1", paddingVertical: 3, paddingHorizontal: 6, fontSize: 8, fontWeight: "bold" }}>Catatan / Notes</Text>
                        <View style={{ padding: 6 }}>
                            {notes.map((note, index) => (
                                <View style={{ flexDirection: "row", marginTop: 1 }} key={index}>
                                    <Text style={{ width: 8, fontSize: 8, color: "#374151" }}>•</Text>
                                    <Text style={{ fontSize: 8, color: "#111827", flex: 1 }}>{note}</Text>
                                </View>
                            ))}
                        </View>
                    </View>
                )}

                <View style={{ flexDirection: "row", marginTop: 6, alignItems: "flex-start" }}>
                    <View style={{ width: "36%" }}>
                        <Text style={{ fontSize: 8, color: "#374151", marginBottom: 2 }}>Penanggung jawab</Text>
                        <Text style={{ fontSize: 8, color: "#374151", marginBottom: 2 }}>Patolog Klinis / Clinical Pathologist</Text>
                        <Image style={{ height: 24, width: 52 }} src="/img/dr. Elvin Richela Lawanto, Sp.PK.png" />
                        <Text style={{ fontSize: 8, fontWeight: "bold", marginTop: 2, width: 120 }}>dr. Elvin Richela Lawanto, Sp.PK</Text>
                    </View>
                    <View style={{ width: "28%", alignItems: "center" }}>
                        <Image source={qrImage} style={{ height: 56, width: 56 }} />
                    </View>
                    <View style={{ width: "36%", alignItems: "flex-end" }}>
                        <Text style={{ fontSize: 8, textAlign: "right" }}>Cilegon, {moment(new Date()).format("DD-MM-YYYY")}</Text>
                        <Text style={{ fontSize: 8, textAlign: "right", color: "#374151", marginBottom: 2 }}>Diotorisasi oleh / Authorized by</Text>
                        <Image style={{ height: 24, width: "auto", marginLeft: "auto" }} src={"/img/" + authorizedBy + ".png"} />
                        <Text style={{ fontSize: 8, fontWeight: "bold", textAlign: "right", marginTop: 2, width: 120 }}>
                            {authorizedBy}
                        </Text>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default function Lab({ patient, labResultData, indicators, authorizedBy, qrImage, notes }) {
    return (
        <BlobProvider document={<MyDocument patient={patient} labResultData={labResultData} indicators={indicators} authorizedBy={authorizedBy} qrImage={qrImage} notes={notes} />}>
            {({ url, loading }) => (
                <a
                    className="btn btn-sm btn-outline-success"
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    download={moment(labResultData.completedAt).format("YYMMDD") + getZeroPad(labResultData.lab_result_no, 3) + " - " + patient.mrn + " - " + labResultData.name + ".pdf"}
                >
                    {loading ? "Loading ..." : "Download PDF - " + labResultData.name}
                </a>
            )}
        </BlobProvider>
    );
}

/*
        <PDFDownloadLink
            className="btn btn-sm btn-outline-success"
            document={<MyDocument patient={patient} labResultData={labResultData} indicators={indicators} authorizedBy={authorizedBy} qrImage={qrImage} notes={notes} />}
            fileName={moment(labResultData.completedAt).format("YYMMDD") + getZeroPad(labResultData.lab_result_no, 3) + " - " + patient.mrn + " - " + labResultData.name + ".pdf"}
        >
            {({ blob, url, loading, error }) => (loading ? "Loading ..." : "Download PDF - " + labResultData.name)}
        </PDFDownloadLink>
    */
